import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import type { Creator } from '@/types';

export function useCreatorDetail(id: string | undefined) {
  return useQuery({
    queryKey: ['creator', id],
    queryFn: async () =>
      pb.collection('leads').getOne<Creator>(id!, {
        expand: 'collector',
      }),
    enabled: !!id,
  });
}
